import { type ReactNode } from "react";
import { FiInfo } from "react-icons/fi";

export default function Field({
  label, children, icon, hint,
}: { label: string; children: ReactNode; icon?: ReactNode; hint?: string; }) {
  const parts = label.split("*");
  const hasAsterisk = parts.length > 1;

  return (
    <label className="block">
      <div className="mb-1 flex items-center gap-1.5 text-xs font-medium text-gray-700">
        {icon ? <span className="text-gray-500">{icon}</span> : null}
        {hasAsterisk ? (
          <span>
            {parts.map((part, idx) => (
              <span key={`${part}-${idx}`}>
                {part}
                {idx < parts.length - 1 ? (
                  <span className="text-rose-600"> *</span>
                ) : null}
              </span>
            ))}
          </span>
        ) : (
          label
        )}

        {/*
          Explanatory copy that would otherwise crowd the form, shown on hover.
          `title` carries the same text so it survives touch and screen readers,
          where a hover-only tooltip would simply not exist. The click guard
          stops a tap on the icon from being forwarded to the wrapped input by
          the surrounding <label>.
        */}
        {hint ? (
          <span
            className="group/hint relative inline-flex cursor-help items-center"
            title={hint}
            onClick={(e) => e.preventDefault()}
          >
            <FiInfo className="h-3.5 w-3.5 text-gray-400 group-hover/hint:text-gray-600" aria-hidden />
            <span className="sr-only">{hint}</span>
            <span
              role="tooltip"
              className="pointer-events-none absolute left-1/2 top-full z-20 mt-1.5 w-72 -translate-x-1/2
                         rounded-lg border border-gray-200 bg-white p-2.5 text-[11px] font-normal
                         leading-relaxed text-gray-600 opacity-0 shadow-lg transition-opacity
                         duration-150 group-hover/hint:opacity-100"
            >
              {hint}
            </span>
          </span>
        ) : null}
      </div>
      {children}
    </label>
  );
}
